import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SessionRow, SessionsProvider } from '../../providers/sessions-provider';
import { SessionItemRow, SessionItemsProvider } from '../../providers/sessionItems-provider';
import { Organization } from "../../../common/models/organization";
import { Subscription } from 'rxjs';
import { TableHistogramChartComponent } from "../../../common/components/table-histogram-chart/table-histogram-chart";
import { NgIf } from "@angular/common";
import { MatError, MatFormField } from "@angular/material/form-field";
import { MatSlider, MatSliderThumb } from "@angular/material/slider";
import { MatInput } from "@angular/material/input";
import { FlexLayoutModule } from "@angular/flex-layout";
import { DurationVerbosePipe } from "../../../common/pipes/duration-verbose";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'sessions-session-general-panel',
  standalone: true,
  providers: [],
  styleUrls: ['./session-general-panel.scss'],
  imports: [
    TableHistogramChartComponent,
    ReactiveFormsModule,
    NgIf,
    MatFormField,
    MatSlider,
    MatInput,
    FlexLayoutModule,
    DurationVerbosePipe,
    TranslateModule,
    FormsModule,
    MatSliderThumb,
    MatError,
  ],
  templateUrl: './session-general-panel.html'
})
export class SessionsGeneralPanelComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input()
  public set session(session: SessionRow) {
    this._session = session;
    if (session) {
      // FG: si on fait pas ce check, on va binder une nouvelle valeur au
      // form control du nombre de répétition ce qui aura pour conséquence
      // d'entregistrer un changement dans le guard ; conséqunce :
      // à chaque fois qu'on enregistre, on nous demande de réenregistrer la page
      // quand on ferme l'éditeur
      if (session.nbRepeat !== this.nbRepeatFormControl.value) {
        this.nbRepeatFormControl.setValue(this._session.nbRepeat);
      }
    } else {
      this.nbRepeatFormControl.setValue(1);
    }
    this.updateTotalTime();
  }

  public get session() {
    return this._session;
  }

  @Input()
  public set sessionItems(sessionItems: SessionItemRow[]) {
    this._sessionItems = sessionItems;
    this.updateTotalTime();
  }

  public get sessionItems() {
    return this._sessionItems;
  }

  @Input() public isMobileDisplay = false;
  @Input() public organization: Organization | null = null;
  @Input() public isEditable = true;
  @Input() public simpleColumn = true;

  @Output() public sessionChange: EventEmitter<SessionRow> = new EventEmitter<SessionRow>();
  @Output() public sessionItemsChange: EventEmitter<SessionItemRow[]> = new EventEmitter<SessionItemRow[]>();
  @Output() public onIntensitySliderChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() public onTotalTimeChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() public onValuesAreGood: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
  @Output() public onValuesAreNotGood: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();

  public totalTimeFormControl: FormControl = new FormControl('', [
    Validators.required
  ]);

  public nbRepeatFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.min(1)
  ]);
  public _totalTime = 0;
  public repeatMinValue = 1;
  private _session: SessionRow = {} as SessionRow;
  private _sessionItems: SessionItemRow[] = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private _sessionItemsProvider: SessionItemsProvider,
    private _sessionsProvider: SessionsProvider,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.detectChanges();
    }

    public ngAfterViewInit() {
        this.subscriptions.push(
            this.nbRepeatFormControl.valueChanges.subscribe(() => {
                this.nbRepeatFormControl.markAsTouched();
                if (this.nbRepeatFormControl.hasError('required') || this.nbRepeatFormControl.hasError('min')) {
                    this.onValuesAreNotGood.emit();
                }else{
                    this.onValuesAreGood.emit();
                }
                this.session.nbRepeat = this.nbRepeatFormControl.value;
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public updateResumedInfo(): void {
        this.updateTotalTime();
        this.updateAdnInfos();
        this.sessionChange.emit(this.session);
        this.cdr.markForCheck();
    }

    private updateTotalTime() {
        if (this._session && this._sessionItems) {
            this._session.totalTime = this._sessionItemsProvider.getTotalTime(this._sessionItems) * this.session.nbRepeat!;
            this._totalTime = this.session.totalTime!;
            this.totalTimeFormControl.setValue(this._totalTime);
        }
    }

    private updateAdnInfos(): void {
        this.session.adn = this._sessionItemsProvider.getAdnInfos(this.sessionItems, 'timelined', this.session.nbRepeat);
        this.session.histogramData = this._sessionsProvider.getHistogramData(this.session);
    }
}
